import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  title: 'גילוי',
  desc: 'מחקר מעמיק, הבנת הצרכים, הגדרת מטרות ואסטרטגיה דיגיטלית.'
}, {
  num: '02',
  title: 'עיצוב',
  desc: 'יצירת סקיצות, עיצוב ממשק משתמש מרהיב ובניית אב-טיפוס אינטראקטיבי.'
}, {
  num: '03',
  title: 'פיתוח',
  desc: 'כתיבת קוד נקי, יעיל ומהיר תוך שימוש בטכנולוגיות המתקדמות ביותר.'
}, {
  num: '04',
  title: 'השקה',
  desc: 'בדיקות מקיפות, אופטימיזציה, עלייה לאוויר ותמיכה שוטפת.'
}];
export function Process() {
  return <section id="process" className="py-32 relative z-20" data-id="element-105">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-106">
        <motion.div className="mb-20" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-107">
          <h2 className="text-5xl md:text-7xl font-display font-black text-white mb-6" data-id="element-108">
            איך אנחנו <span className="text-gradient" data-id="element-109">עובדים</span>
          </h2>
        </motion.div>

        <div className="relative" data-id="element-110">
          {/* Line */}
          <div className="absolute top-0 md:top-12 right-8 md:right-0 w-0.5 h-full md:w-full md:h-0.5 bg-white/10" data-id="element-111" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 relative" data-id="element-112">
            {steps.map((step, index) => <motion.div key={index} className="relative pl-16 md:pl-0 pt-0 md:pt-24" initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.8,
            delay: index * 0.2
          }} data-id="element-113">
                {/* Node */}
                <div className="absolute top-0 right-0 md:right-auto md:left-1/2 md:-translate-x-1/2 w-16 h-16 md:w-24 md:h-24 rounded-full bg-[#0a0a0f] border-2 border-white/20 flex items-center justify-center text-2xl md:text-3xl font-display font-black text-white/40 z-10" data-id="element-114">
                  {step.num}
                </div>

                <h3 className="text-2xl font-display font-bold text-white mb-4 mt-2 md:mt-0 md:text-center" data-id="element-115">
                  {step.title}
                </h3>
                <p className="text-white/60 md:text-center leading-relaxed" data-id="element-116">
                  {step.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}